(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["@logilab/cwelements"] = factory(require("react"));
	else
		root["@logilab/cwelements"] = factory(root["react"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__2__) {
return 